import { lazy, Suspense } from "react";
import CircularLoader from "../../custom/circularLoader/circularLoader";

const Main = lazy(() => import("../../components/landingPage/requirements/main"));

const ExamRequirements = () => {
    return (
        <Suspense fallback={<CircularLoader />}>
            <Main />
        </Suspense>
    )
}
export default ExamRequirements